import './styles/index.scss';
/* import $ from "jquery"; */
/* import 'bootstrap'; */

window.onload = function () {
  document.documentElement.classList.remove('preload');
  document.querySelector('.preloader').classList.add('hidden');
  document.querySelector('h1').classList.add('active');
}

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener('load', () => {
    /* if (document.querySelector('body').offsetWidth <= 767) {
      const cols = gsap.utils.toArray('.items_wrap .col_scrool');

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#howtouse',
          start: 'top top-=80',
          end: () => '+=' + ((cols.length * 1000)),
          scrub: true, 
          pin: true,
          pinSpacing: true
        }
      });

      cols.forEach((col, i) => {
        tl.to(col, {
          opacity: 1,
          y: 0,
          delay: 0.3,
          duration: 1
        }, i);
      });
    } */
});


let ctx = gsap.context(() => {
  ScrollTrigger.create({
    trigger: ".main",
    start: "top top+=1px",
    end: "bottom top",
    toggleClass: {
      targets: "#header",
      className: "is-scrolled"
    }
  });

  ScrollTrigger.create({
    trigger: ".main",
    start: "bottom-=1000px top",
    end: "bottom top",
    toggleClass: {
      targets: "#header",
      className: "hide-header"
    },
  });
});

let ctx2 = gsap.context(() => {
  const sections = gsap.utils.toArray('[id]');
  const navLinks = document.querySelectorAll('.nav_wrap a[href^="#"]');

  sections.forEach((section, i) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        navLinks.forEach(link => link.classList.remove('nav--active'));
        const targetLink = document.querySelector(`a[href="#${section.id}"]`);
        if (targetLink) targetLink.classList.add('nav--active');
      },
      onEnterBack: () => {
        navLinks.forEach(link => link.classList.remove('nav--active'));
        const targetLink = document.querySelector(`a[href="#${section.id}"]`);
        if (targetLink) targetLink.classList.add('nav--active');
      }
    });
  });
});

document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const targetPosition = targetElement.offsetTop - 80;

      gsap.to(window, {
        duration: 0,
        scrollTo: targetPosition,
        ease: "power2.inOut"
      });
    }
    if (document.querySelector('body').offsetWidth <= 767) {
      console.log(document.querySelector('body').offsetWidth);
      
      document.querySelector('header .burger_icon').classList.remove('active');
      document.querySelector('header .nav_wrap').classList.remove('active');
      
      document.querySelector('footer .burger_icon').classList.remove('active');
      document.querySelector('footer .nav_wrap').classList.remove('active');
    }
  });
});

gsap.utils.toArray('.animFromTop').forEach(block => {
  gsap.to(block, {
    scrollTrigger: {
      trigger: block,
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
    y: 0,
    opacity: 1,
    duration: 1,
    ease: 'power2.out'
  });
});

gsap.utils.toArray('.hero2_prod_wrap').forEach(block => {
  gsap.to(block, {
    scrollTrigger: {
      trigger: block,
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
    x: 0,
    opacity: 1,
    duration: 1,
    ease: 'power2.out'
  });
});

gsap.utils.toArray('.howwork_bg').forEach(block => {
  gsap.to(block, {
    scrollTrigger: {
      trigger: block,
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
    x: 0,
    opacity: 1,
    duration: 1,
    ease: 'power2.out'
  });
});

gsap.utils.toArray('.hero2_prod_t').forEach((block, i) => {
  gsap.fromTo(block, {
    opacity: 0,
    y: 50
  }, {
    opacity: 1,
    y: 0,
    duration: 0.8,
    delay: i * 0.5,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: block,
      start: 'top 85%',
      toggleActions: 'play none none none'
    }
  });
});

gsap.utils.toArray('.comfort_pers').forEach(block => {
  gsap.to(block, {
    scrollTrigger: {
      trigger: block,
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
    x: 0,
    opacity: 1,
    duration: 1,
    ease: 'power2.out'
  });
});

gsap.to('.end_pic', {
  yPercent: -20,
  ease: 'none',
  scrollTrigger: {
    trigger: '.end',
    start: 'top bottom',
    end: 'bottom top',
    scrub: true
  }
});


document.querySelector('header .burger_icon').onclick = function () {
  document.querySelector('header .burger_icon').classList.toggle('active');
  document.querySelector('header .nav_wrap').classList.toggle('active');
}

document.querySelector('footer .burger_icon').onclick = function () {
  document.querySelector('footer .burger_icon').classList.toggle('active');
  document.querySelector('footer .nav_wrap').classList.toggle('active');
}